<template>
  <div id="points" class="container">
    <div class="bread">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>积分商城</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div
      class="banner"
      v-bind:style="{backgroundImage:'url(' + serve + banner + ')'}"
    ></div>
    <div class="box">
      <el-row>
        <el-col :span="18" style="line-height:35px;font-size:12px">
          <div>
            <div>
              <span>排序：</span>
              <span class="i1" :class="orderBy==null?'active':''" @click="orderBy=null">默认排序</span>
              <span class="i1" :class="orderBy=='time'?'active':''" @click="orderBy='time'">上架时间</span>
              <span
                class="i1"
                :class="orderBy=='integral_up'?'active':''"
                @click="orderBy='integral_up'"
              >积分高优先</span>
              <span
                class="i1"
                :class="orderBy=='integral_down'?'active':''"
                @click="orderBy='integral_down'"
              >积分低优先</span>
            </div>
            <div class="clear">
              <span class="clear-item">价格范围：</span>
              <span class="clear-item">
                <el-input v-model="min" size="mini" style="width:80px;"></el-input>
              </span>
              <span class="clear-item" style="margin:0 10px;">-</span>
              <span class="clear-item">
                <el-input v-model="max" size="mini" style="width:80px;"></el-input>
              </span>
            </div>
            <div>
              <el-row>
                <el-col :span="2">
                  <div>关键字：</div>
                </el-col>
                <el-col :span="6">
                  <div>
                    <el-input placeholder="请输入商品名称" v-model="keywords" size="mini">
                      <el-button slot="append" @click="search">搜索</el-button>
                    </el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <div style="font-size:20px;line-height:105px;">我的积分：{{my}}积分</div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="box b2" style="margin-top:20px;">
      <el-row :gutter="20">
        <el-col :span="6" v-for="(item,index) of data" :key="index">
          <div class="item">
            <el-card :body-style="{ padding: '0px' }">
              <img :src="serve+_.split(item.images, ';', 1)" class="cover">
              <div style="text-align:center">
                <div class="t1 lv2Text">
                  {{_.truncate(item.title, {
                  'length': 15,
                  'separator': ' ...'
                  })}}
                </div>
                <div class="t3 lv0Text">
                  <el-row>
                    <el-col :span="12">
                      <div style="line-height:32px">{{item.integral}}积分</div>
                    </el-col>
                    <el-col :span="12">
                      <div>
                        <el-button round size="small" @click="go(item.inte_id)">立即兑换</el-button>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="pager" align="center">
      <el-pagination
        :page-size="16"
        background
        hide-on-single-page
        layout="prev, pager, next"
        :total="total"
        @current-change="pageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,

      //
      keywords: "",
      orderBy: null,
      max: "",
      min: "",
      data: {},
      total: 0,
      page: 1,
      banner: "",
      my: 0
    };
  },
  created() {
    this.initData();

  },
   activated() {
    this.$store.commit("set_top_nav", "6");
  },
  methods: {
    //
    go(id) {
      this.$router.push("/user/viewPoint?id=" + id);
    },
    reload() {
      this.axios
        .get(this.serve + "/integral", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: this.page,
            upper: this.max,
            lower: this.min,
            key: this.keywords,
            sort: this.orderBy
          }
        })
        .then(res => {
          this.data = res.data.data.results;
          this.total = res.data.data.total;
        });
    },
    pageChange(v) {
      this.page = v;
      this.reload();
    },
    search() {
      this.reload();
    },
    initData() {
      ///member/get_integral_number
      this.axios
        .get(this.serve + "/member/get_integral_number", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.my = res.data;
        });
      this.axios
        .get(this.serve + "/get_banner?type=integral")
        .then(res => {
          this.banner = res.data.data.image;
        });
      this.axios.get(this.serve + "/integral").then(res => {
        this.data = res.data.data.results;
        this.total = res.data.data.total;
      });
    }
  }
};
</script>
<style lang="scss">
#points {
  .item {
    background-color: #ffe5e8;
  }
  .t2 {
    padding: 20px 0;
  }
  .t1 {
    padding: 20px 0 20px 0;
    border-bottom: 1px solid #ddd;
  }
  .t3 {
    margin: 10px 0;
  }
  .cover {
    display: block;
    width: 273px;
    height: 273px;
  }
  padding-bottom: 40px;
  .item {
    margin-bottom: 20px;
  }
  .i1 {
    margin-right: 8px;
    padding: 3px 10px;
    cursor: pointer;
  }
  .el-input-group__append {
    background-color: #e2211c;
    color: #fff;
  }
  .i1.active {
    background-color: #e2211c;
    color: #fff;
    border-radius: 8px;
  }
  .banner {
    margin-bottom: 20px;
    height: 350px;
  }
  .box {
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 10px 20px;
  }
  .box.b2 {
    padding-top: 40px;
    padding-bottom: 50px;
    border: 0;
  }
}
</style>